import { get, put } from '../../api';
import { timeToMoment } from '@utils';

export const getHorarioFuncionamento = async (idConfiguracao) => {
  const res = await get(`/api/conectores/horario/${idConfiguracao}`);
  let result = {};

  res.forEach((horario) => {
    result[`horario${horario.nrDiaSemana}`] = [timeToMoment(horario.hrInicio), timeToMoment(horario.hrFim)];
  });

  return result;
};

export const putHorarioFuncionamento = (data) => {
  return put('/api/conectores/horario', data);
};
